/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Team_History_UpdatedInputs */



/**
* | output |
* | --- |
* | "Updated on {date}" |
*
* @param {Team_History_UpdatedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_history_updated = /** @type {((inputs: Team_History_UpdatedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_History_UpdatedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Bijgewerkt op ${i?.date}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Mis à jour le ${i?.date}`)
	return /** @type {LocalizedString} */ (`Updated on ${i?.date}`)
});